import { observer } from 'mobx-react';
import * as React from 'react';
import ModalReactions from '../../../../Modal/ModalReactions';
import ShareModal, { Props } from './ShareModal';

const Share: React.FC<Props> = (props) => (
  <>
    <ShareModal {...props} />
    <ModalReactions store={props.shareModalStore} />
  </>
);

export default observer(Share);
